export default "mdc-dialog-surface {\n  min-width: 480px !important;\n  overflow: hidden;\n}"